import Icon from '../../components/Icon.vue'

Icon.register({"brands/superpowers":{"width":448,"height":512,"paths":[{"d":"M448 32C364.7 43 281.2 54 198 65 106 77.5 34.7 151.7 29 245 25.7 300.5 47 354.5 86.8 393.2L0 480C83.3 469 166.5 458 249.8 447 341.6 434.5 413.1 360.2 418.5 267.2 422 211.7 400.5 157.7 360.8 119L448 32zM368.3 264.3C364.1 343.8 294.3 403.5 215.5 398.8 136 394.1 74.8 327.8 79.2 247.8 83.7 168.6 153.5 108.5 232.2 113.3 311.5 118 372.7 184.3 368.3 264.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/superpowers.js
// module id = 2uhj
// module chunks = 0